/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';


export const getAlipayUserInfo = easyPost('user.account.getAlipayUserInfo');

export const getForestRecord = easyPost('user.taurus.issueRecords');

export const getForestPointsInfo = easyPost('user.taurus.pointInfo');

export const getForestAccountStatus = easyPost('user.taurus.accountStatus');

export const openForest = easyPost('user.account.antForestOpen');

export const closeForest = easyPost('user.taurus.closeAccount');

export const bindAlipayUser = easyPost('user.account.antForestAuth');

export const shouldShowWarnModal = easyPost('bike.greenEnergy.popup', {
  api: config.BIKE_API,
});

export const updateAuth = easyPost('user.taurus.updateAntGenAccount');

export const getForestStatus = easyPost('new.mytab.config.antPoint');
